
import Component from 'vue-class-component'
import Vue from 'vue'
import TemplateManagement from '../components/template-manage/TemplateManagement.vue'

/**
 * 웹파트 페이지의 템플릿을 관리하는 화면
 * 템프릿을 추가/제거/편집 할 수 있다.
 */
@Component({
    components: { TemplateManagement },
})
export default class TempateManageView extends Vue {}
